// src/features/notifications/notificationsAPI.js
import { apiSlice } from "../api/apiSlice"; 

export const notificationsAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => 'api/v1/notifications',
    }),
    markNotificationAsRead: builder.mutation({
      query: (id) => ({
        url: `api/v1/notifications/mark-as-read/${id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetNotificationsQuery, useMarkNotificationAsReadMutation } = notificationsAPI;
